export enum MRT_BLUE_STATION_ID {
    THAPHRA = "BL01",
    CHARAN_13 = "BL02",
    FAI_CHAI = "BL03",
    BANG_KHUN_NON = "BL04",
    BANG_YI_KHAN = "BL05",
    SIRINDHORN = "BL06",
    BANG_PHLAT = "BL07",
    BANG_O = "BL08",
    BANG_PHO = "BL09",
    TAO_POON = "BL10",
    BANG_SUE = "BL11",
    KAMPHAENG_PHET = "BL12",
    CHATUCHAK_PARK = "BL13",
    PHAHON_YOTHIN = "BL14",
    LAT_PHRAO = "BL15",
    RATCHADAPHISEK = "BL16",
    SUTTHISAN = "BL17",
    HUAI_KHWANG = "BL18",
    THAILAND_CULTURAL_CENTRE = "BL19",
    PHRA_RAM_9 = "BL20",
    PHETCHABURI = "BL21",
    SUKHUMVIT = "BL22",
    QUEEN_SIRIKIT_NATIONAL_CONVENTION_CENTRE = "BL23",
    KHLONG_TOEI = "BL24",
    LUMPHINI = "BL25",
    SILOM = "BL26",
    SAM_YAN = "BL27",
    HUA_LAMPHONG = "BL28",
    WAT_MANGKON = "BL29",
    SAM_YOT = "BL30",
    SANAM_CHAI = "BL31",
    ITSARAPHAP = "BL32",
    BANG_PHAI = "BL33",
    BANG_WA = "BL34",
    PHETKASEM_48 = "BL35",
    PHASI_CHAROEN = "BL36",
    BANG_KHAE = "BL37",
    LAK_SONG = "BL38"
}

export enum MRT_PURPLE_STATION_ID {
    KHLONG_BANG_PHAI = "PP01",
    TALAD_BANG_YAI = "PP02",
    SAM_YAEK_BANG_YAI = "PP03",
    BANG_PHLU = "PP04",
    BANG_RAK_YAI = "PP05",
    BANG_RAK_NOI_THA_IT = "PP06",
    SAI_MA = "PP07",
    PHRA_NANG_KLAO_BRIDGE = "PP08",
    YAEK_NONTHABURI_1 = "PP09",
    BANG_KRASO = "PP10",
    NONTHABURI_CIVIC_CENTER = "PP11",
    MINISTRY_OF_PUBLIC_HEALTH = "PP12",
    YAEK_TIWANON = "PP13",
    WONG_SAWANG = "PP14",
    BANG_SON = "PP15",
    TAO_POON = "PP16"
}

export enum BTS_SILOM_STATION_ID {
    NATIONAL_STADIUM = "W1",
    SIAM = "CEN",
    RATCHADAMRI = "S1",
    SALA_DAENG = "S2",
    CHONG_NONSI = "S3",
    SAINT_LOUIS = "S4",
    SURASAK = "S5",
    SAPHAN_TAKSIN = "S6",
    KRUNG_THON_BURI = "S7",
    WONGWIAN_YAI = "S8",

    PHO_NIMIT = "S9",
    TALAT_PHLU = "S10",
    WUTTHAKAT = "S11",
    BANG_WA = "S12",
}

export enum BTS_SUKHUMVIT_STATION_ID {
    KHU_KHOT = "N24",
    YAEK_KOR_POR_AOR = "N23",
    ROYAL_THAI_AIR_FORCE_MUSEUM = "N22",
    BHUMIBOL_ADULYADEJ_HOSPITAL = "N21",
    SAPHAN_MAI = "N20",
    SAI_YUD = "N19",
    PHAHON_YOTHIN_59 = "N18",
    WAT_PHRA_SRI_MAHATHAT = "N17",
    INFANTRY_REGIMENT_11 = "N16",
    BANG_BUA = "N15",
    ROYAL_FOREST_DEPARTMENT = "N14",
    KASETSART_UNIVERSITY = "N13",
    SENA_NIKHOM = "N12",
    RATCHAYOTHIN = "N11",
    PHAHON_YOTHIN_24 = "N10",
    HA_YEAK_LAT_PHRAO = "N9",

    MO_CHIT = "N8",
    SAPHAN_KHWAI = "N7",
    SENA_RUAM = "N6",
    ARI = "N5",
    SANAM_PAO = "N4",
    VICTORY_MONUMENT = "N3",
    PHAYA_THAI = "N2",
    RATCHATHEWI = "N1",
    SIAM = "CEN",
    CHIT_LOM = "E1",
    PHOLEN_CHIT = "E2",
    NANA = "E3",
    ASOK = "E4",
    PHROM_PHONG = "E5",
    THONG_LO = "E6",
    EKKAMAI = "E7",
    PHRA_KHANONG = "E8",

    ON_NUT = "E9",
    BANG_CHAK = "E10",
    PUNNAWITHI = "E11",
    UDOM_SUK = "E12",
    BANG_NA = "E13",
    BEARING = "E14",

    SAMRONG = "E15",
    PU_CHAO = "E16",
    CHANG_ERAWAN = "E17",
    ROYAL_THAI_NAVAL_ACADEMY = "E18",
    PAK_NAM = "E19",
    SRINAGARINDRA = "E20",
    PHRAEK_SA = "E21",
    SAI_LUAT = "E22",
    KHEHA = "E23",
}

export enum ARL_STATION_ID {
    SUVARNABHUMI = "A1",
    LAT_KRABANG = "A2",
    BAN_THAP_CHANG = "A3",
    HUA_MAK = "A4",
    RAMKHAMHAENG = "A5",
    MAKKASAN = "A6",
    RATCHAPRAROP = "A7",
    PHAYA_THAI = "A8",
}

export enum BRT_STATION_ID {
    SATHON = "B1",
    AKHAN_SONGKHRO = "B2",
    TECHNIC_KRUNGTHEP = "B3",
    THANON_CHAN = "B4",
    NARARAM_III = "B5",
    WAT_DAN = "B6",
    WAT_PARIWAT = "B7",
    WAT_DOKMAI = "B8",
    RAMA_IX_BRIDGE = "B9",
    CHAROENRAT = "B10",
    RAMA_III_BRIDGE = "B11",
    RATCHAPRUEK = "B12"
}

export enum BTS_GOLD_ID {
    KRUNG_THON_BURI = "G1",
    CHAROEN_NAKHON = "G2",
    KHLONG_SAN = "G3",
}

export type METRO_STATION_ID =
    MRT_BLUE_STATION_ID |
    MRT_PURPLE_STATION_ID |
    BTS_SILOM_STATION_ID |
    BTS_SUKHUMVIT_STATION_ID |
    ARL_STATION_ID |
    BRT_STATION_ID |
    BTS_GOLD_ID;
